import { httpStatusCodes } from 'redux-resource-plugins';
import { resourceReducer } from 'redux-resource';


export default resourceReducer('invoices', { plugins: [ httpStatusCodes ] });
